import OperationFormPage from "./OperationFormPage";

const TroubleshootingGuideFormPage = () => <OperationFormPage resource="guides" />;

export default TroubleshootingGuideFormPage;
